import { arrayRemove, arrayUnion, doc, setDoc } from "firebase/firestore";
import { useCallback, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { auth, db } from "../firebase";
import { useEffect } from "react";
import Document from "./document";
import WhatsApp from "./whatsApp";
import Gala from "./gala";
import Season from "./season";
import Holiday from "./holiday";
import NewSeason from "./newSeason";

export default function WaiterUser({u, locations, groups}) {

    const [on, setOn] = useState(false)

    const copyToClipboard = (str) => {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        el.focus();
        document.execCommand('copy');
        document.body.removeChild(el);
    };

    function numberToPolishWeekday(num) {
        const days = {
          1: "Poniedziałek",
          2: "Wtorek",
          3: "Środa",
          4: "Czwartek",
          5: "Piątek",
          6: "Sobota",
          7: "Niedziela"
        };
        
        return days[num] || "Niepoprawny numer dnia (1–7)";
    }

const getGroups = useCallback(() => {
  // bezpieczne kopie
  const grpArr = Array.isArray(groups) ? groups : [];
  const locArr = Array.isArray(locations) ? locations : [];

  // prices może nie istnieć lub być puste
  const rawPrices = u?.user?.prices;
  const hasPrices =
    rawPrices && typeof rawPrices === "object" && Object.keys(rawPrices).length > 0;
  const pricesMap = hasPrices ? rawPrices : null;

  const TypeBadge = ({ type }) => {
    let base = {
      fontSize: 10,
      fontWeight: 700,
      padding: "2px 6px",
      borderRadius: 8,
      whiteSpace: "nowrap",
      display: "inline-block",
    };

    if (type === "entry") {
      return (
        <span
          style={{
            ...base,
            background: "rgba(255,99,71,.10)",
            border: "1px solid rgba(255,99,71,.25)",
            color: "#B54708",
          }}
        >
          wejście jednorazowe
        </span>
      );
    }
    if (type === "contract") {
      return (
        <span
          style={{
            ...base,
            background: "rgba(0,69,199,.10)",
            border: "1px solid rgba(0,69,199,.25)",
            color: "#0A66FF",
          }}
        >
          umowa
        </span>
      );
    }
    // missing
    return (
      <span
        style={{
          ...base,
          background: "rgba(220,38,38,.10)",
          border: "1px solid rgba(220,38,38,.25)",
          color: "#B91C1C",
        }}
      >
        brak typu
      </span>
    );
  };

  const resolveType = (gid) => {
    if (!pricesMap) return "missing";
    const v = pricesMap[gid];
    if (v === "entry") return "entry";
    if (v === "contract") return "contract";
    return "missing";
  };

  return (u?.user?.groups || []).map((gId) => {
    const groupData = grpArr.find((x) => x?.id === gId);
    if (!groupData) return null;

    const locationName =
      locArr.find((x) => x?.id === groupData?.location_id)?.name || "";

    const dayData = groupData?.days?.[0];
    const dayInfo = dayData
      ? dayData.custom_name
        ? dayData.custom_name
        : `${numberToPolishWeekday(dayData.weekDay)} - ${dayData.startTime} - ${dayData.endTime} - ${groupData.type} - ${groupData?.id}`
      : "";

    const mtype = resolveType(gId);

    return (
      <div
        key={gId}
        style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 2 }}
      >
        <h3 style={{ fontSize: 12, color: "rgb(30,30,30)", margin: 0 }}>
          {locationName} - {dayInfo}
        </h3>
        <TypeBadge type={mtype} />
      </div>
    );
  });
}, [u, groups, locations]);


    return (
        <div style={({display: "flex", justifyContent: "flex-start", alignItems: "center", flexDirection: "column", gap: "5px", borderBottom: "1px solid rgb(30,30,30,0.15)", padding: "5px", minWidth: "90%", transition: "0.5s"})}>
            <div style={({display: "flex", justifyContent: "flex-start", alignItems: "center", flexDirection: "row", gap: "10px", minWidth: "100%"})}>
                <div style={({display: 'flex', flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "8px", marginRight: "5px"})}>
                </div>
                <div style={({display: 'flex', flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", gap: "0px", width: "47.5%"})}>
                    <h3 style={({fontSize: "12px", color: "rgb(30,30,30)"})}>{u?.user?.displayName}</h3>
                    <h3 style={({fontSize: "11px", color: "rgb(50,50,50)", fontWeight: 'normal'})}>{u?.acc?.parent?.displayName}</h3>
                </div>
                <div style={({display: 'flex', flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", gap: "0px", width: "47.5%"})}>
                    <h3 style={({fontSize: "12px", color: "rgb(30,30,30)"})}>{u?.acc?.parent?.phone}</h3>
                    <h3 style={({fontSize: "11px", color: "rgb(50,50,50)", fontWeight: 'normal'})}>{u?.acc?.email}</h3>
                </div>
                <div style={({display: 'flex', flexDirection: "row", justifyContent: "flex-start", alignItems: "flex-start", gap: "10px", marginRight: "5px"})}>

                    <div style={({display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", height: "18px", width: "18px", borderRadius: "5px", backgroundColor: "rgb(0,0,0,0)", padding: "3px", transition: "0.6s", marginTop: "3px", cursor: "pointer"})} onClick={() => setOn(!on)}>
                        <img src={on ? process.env.PUBLIC_URL + "/arrow_close.png" : process.env.PUBLIC_URL + "/arrow_open.png"} style={({width: "22px"})} />
                    </div>
                </div>
            </div>
            {on &&
                <div style={({display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "column", gap: "10px", width: "100%", transition: "0.5s", borderTop: "1px solid rgb(30,30,30,0.15)", paddingTop: "15px"})}> 
                    {getGroups()}
                    <div style={({display: 'flex', flexDirection: "row", justifyContent: "flex-start", alignItems: "flex-start", gap: "8px"})}>
                        <h3 style={({fontSize: "12px", color: "rgb(30,30,30, 0.9)", fontWeight: "normal", width: "100px"})}>Data urodzenia:</h3>
                        <h3 style={({fontSize: "12px", color: "rgb(30,30,30)"})}>{u?.user?.dateOfBirth}</h3>
                        <h3 style={({fontSize: "12px", color: "rgb(30,30,30)"})}>{u?.user?.pesel}</h3>
                    </div>
                    <div style={({display: 'flex', flexDirection: "row", justifyContent: "flex-start", alignItems: "flex-start", gap: "8px"})}>
                        <h3 style={({fontSize: "12px", color: "rgb(30,30,30, 0.9)", fontWeight: "normal", width: "100px"})}>Odbiór na zajęcia:</h3>
                        <h3 style={({fontSize: "12px", color: "rgb(30,30,30)"})}>{(u?.user?.pickUp && u?.user?.pickUp !== "brak") ? ((u?.user?.pickUp === "nie" || u?.user?.pickUp === "Nie") ? "Nie odbierać" : "Odebrać") + ((u?.user?.class && u?.user?.class !== "brak") ? " " + u?.user?.class : "") : "Nie dotyczy"}</h3>
                    </div>
                    <div style={({display: 'flex', flexDirection: "row", justifyContent: "flex-start", alignItems: "flex-start", gap: "8px"})}>
                        <h3 style={({fontSize: "12px", color: "rgb(30,30,30, 0.9)", fontWeight: "normal", width: "100px"})}>ID użytkownika:</h3>
                        <h3 style={({fontSize: "12px", color: "rgb(30,30,30)"})}>{u?.uid}</h3>
                    </div>
                    <div style={({display: 'flex', flexDirection: "row", justifyContent: "flex-start", alignItems: "flex-start", gap: "8px", marginTop: "5px", marginBottom: "3px"})}>
                        <Link style={({textDecoration: "none"})} to={"/listy/" + u?.uid} target="_blank">
                            <div style={({display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", height: "18px", width: "18px", borderRadius: "5px", backgroundColor: "rgb(0,0,0,0)", padding: "4px", border: "2px solid #0045C7", transition: "0.6s", cursor: "pointer"})}>
                                <img src={process.env.PUBLIC_URL + "/profile.png"} style={({width: "27px"})} />
                            </div>
                        </Link>
                        <div style={({display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", height: "18px", width: "18px", borderRadius: "5px", backgroundColor: "rgb(0,0,0,0)", padding: "4px", border: "2px solid #0045C7", transition: "0.6s", cursor: "pointer"})} onClick={(e) => {e?.stopPropagation(); copyToClipboard(u?.user?.displayName + " - " + u?.acc?.parent?.phone + " - " + u?.acc?.uid)}}>
                            <img src={process.env.PUBLIC_URL + "/clipboard.png"} style={({width: "25px"})} />
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}            

